import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/app-shell'
import { Spinner } from './components/states'
import { useAdmin } from './lib/session'
import { LoginPage } from './pages/login'
import { BootstrapPage } from './pages/bootstrap'
import { DashboardPage } from './pages/dashboard'
import { UsersPage } from './pages/users'
import { UserDetailPage } from './pages/user-detail'
import { SubscriptionsPage } from './pages/subscriptions'
import { SubscriptionDetailPage } from './pages/subscription-detail'
import { CouponsPage } from './pages/coupons'
import { LogsPage } from './pages/logs'
import { CustomerJourneyPage } from './pages/customer-journey'
import { SupportInboxPage } from './pages/support-inbox'
import { AdminsPage } from './pages/admins'

// Everything behind this is gated on the backend confirming an active admin
// session — a valid cookie alone is not enough (a deactivated admin still has
// one), so the answer has to come from /api/admin/me.
function Protected() {
	const { data: admin, isLoading, isError } = useAdmin()
	if (isLoading) return <Spinner label="Checking your session…" />
	if (isError || !admin) return <Navigate to="/login" replace />
	return <AppShell admin={admin} />
}

export function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/login" element={<LoginPage />} />
				<Route path="/bootstrap" element={<BootstrapPage />} />
				<Route element={<Protected />}>
					<Route path="/dashboard" element={<DashboardPage />} />
					<Route path="/users" element={<UsersPage />} />
					<Route path="/users/:id" element={<UserDetailPage />} />
					<Route path="/subscriptions" element={<SubscriptionsPage />} />
					<Route path="/subscriptions/:id" element={<SubscriptionDetailPage />} />
					<Route path="/coupons" element={<CouponsPage />} />
					<Route path="/customer-journey" element={<CustomerJourneyPage />} />
					<Route path="/support" element={<SupportInboxPage />} />
					<Route path="/logs" element={<LogsPage />} />
					<Route path="/admins" element={<AdminsPage />} />
				</Route>
				<Route path="*" element={<Navigate to="/dashboard" replace />} />
			</Routes>
		</BrowserRouter>
	)
}
